import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanStockTarget } from "./stock-target";
import { QuestionPlanStockTerm } from "./stock-term";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	stock: PlanCategoriesAndManagerStore["stock"];
};

export const QuestionPlanStock = ({ stock }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="在庫設定" categoryStore={stock}>
			<QuestionPlanStockTarget />
			<QuestionPlanStockTerm />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanStock.displayName = "QuestionPlanStock";
